import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: process.env.REACT_APP_REQUEST_TIMEOUT
    ? parseInt(process.env.REACT_APP_REQUEST_TIMEOUT, 10)
    : 10000, // tempo em milissegundos
  headers: {
    Authorization: localStorage.getItem("token")
      ? "Bearer " + localStorage.getItem("token")
      : "",
  },
});

api.interceptors.response.use(
  function (response) {
    return response;
  }
  // function (error) {
  //   if (error.response.status === 444) {
  //     window.location.href = "/acesso-restrito";
  //   }
  //   return Promise.reject(error);
  // }
);

export default api;
